export default (element) => {
  const body = document.querySelector('body');
  const hamburger = element.querySelector('[data-target="hamburger"]');
  const megaMenus = element.querySelectorAll('[data-target="mega-menu"]');
  const closeMegaMenus = element.querySelectorAll(
    '[data-target="close-mobile-mega"]',
  );

  const openSearchBtn = element.querySelector(
    '[data-target="open-search-button"]',
  );
  const searchInputs = element.querySelectorAll('[data-target="search-input"]');
  const searchOverlays = element.querySelectorAll(
    '[data-target="search-overlay"]',
  );

  const closeSearchbtns = element.querySelectorAll(
    '[ data-target="close-search"]',
  );

  const accordionTriggers = element.querySelectorAll(
    '[data-target="mega-accordion"]',
  );

  const subMegaPanels = element.querySelectorAll(
    '[data-target="sub-mega-panel"]',
  );

  const sizeGuideTrigger = document.querySelectorAll(
    '[data-target="open-sizeguide"]',
  );

  const sizeGuideClose = document.querySelectorAll(
    '[data-target="close-sizeguide"]',
  );
  const sizeGuideOverlay = document.querySelectorAll(
    '[data-target="size-guide-overlay"]',
  );

  const searchButtons = element.querySelectorAll('[data-search-button]');

  const pills = element.querySelectorAll('[data-search-suggest]');

  const openMenuClass = 'open-menu';

  let lastScrollTop = 0;

  const init = () => {
    hamburger.addEventListener('click', toggleMenu);

    openSearchBtn.addEventListener('click', openSearch);

    searchInputs.forEach((item) => {
      item.addEventListener('click', () => {
        openSearch();
      });
      item.addEventListener('input', (e) => {
        if (e.currentTarget.value) {
          body.classList.add('search-typed');
        } else {
          body.classList.remove('search-typed');
        }
        highlightPills(e.currentTarget.value);
      });
    });

    searchOverlays.forEach((item) => {
      item.addEventListener('click', (event) => {
        if (event.currentTarget === event.target) {
          closeSearch();
        }
      });
    });

    closeSearchbtns.forEach((item) => {
      item.addEventListener('click', () => {
        closeSearch();
      });
    });

    megaMenus.forEach((item) => {
      item.addEventListener('click', (event) => {
        toggleSubMegaMenu(event, item);
        removeInert();
      });
    });

    closeMegaMenus.forEach((item) => {
      item.addEventListener('click', (event) => {
        addInert();
        toggleSubMegaMenu(event, item);
      });
    });

    accordionTriggers.forEach((item) => {
      item.addEventListener('click', (event) => {
        toggleAccordion(event, item);
      });
    });

    pills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        inputSearch(e.currentTarget.dataset.searchSuggest);
      });
    });

    sizeGuideTrigger?.forEach((item) => {
      item.addEventListener('click', () => {
        openSizeGuide(item);
      });
    });

    sizeGuideClose?.forEach((item) => {
      item.addEventListener('click', () => {
        closeSizeGuide();
      });
    });

    sizeGuideOverlay?.forEach((item) => {
      item.addEventListener('click', (event) => {
        if (event.currentTarget === event.target) {
          closeSizeGuide(event);
        }
      });
    });

    searchButtons.forEach((btn) =>
      btn.addEventListener('click', searchRedirect),
    );

    window.addEventListener(
      'scroll',
      () => {
        togglePromoBar(body);
      },
      false,
    );

    let prevWindowWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      if (window.innerWidth !== prevWindowWidth) {
        removeClassControls();
        prevWindowWidth = window.innerWidth;
      }
    });
  };

  const openSizeGuide = (item) => {
    const sizeGuideTargetHandle = item.getAttribute('data-size-guide-handle');
    const sizeGuideTarget = document.querySelector(
      `[data-size-guide="${sizeGuideTargetHandle}"]`,
    );
    sizeGuideTarget.classList.add('open-sizeguide');
    body.classList.add('overflow-hidden');
  };

  const closeSizeGuide = () => {
    const elements = document.querySelectorAll('.open-sizeguide');

    elements.forEach((item) => {
      item.classList.remove('open-sizeguide');
    });

    body.classList.remove('overflow-hidden');
  };

  const openSearch = () => {
    body.classList.add('search-open');
  };

  const closeSearch = () => {
    body.classList.remove('search-open');
  };

  const toggleMenu = () => {
    if (body.classList.contains(openMenuClass)) {
      body.classList.remove(openMenuClass);
      removeInert();
    } else {
      body.classList.add(openMenuClass);
      addInert();
    }
    closeSubMegaMenu();
    closeSearch();
  };

  const toggleSubMegaMenu = (event, target) => {
    if (event.currentTarget === target) {
      const dataTarget = event.currentTarget.getAttribute('data-target');
      if (dataTarget === 'mega-menu') {
        target.parentElement.classList.toggle('mobile-mega');
      } else {
        target.closest('.mobile-mega')?.classList.remove('mobile-mega');
      }
    }
  };

  const toggleAccordion = (event, target) => {
    const elements = document.querySelectorAll('.active-accordion');
    let pastActiveElement;

    if (target.parentElement.classList.contains('active-accordion')) {
      pastActiveElement = target;
    }

    elements.forEach((accordionButton) => {
      accordionButton.classList.remove('active-accordion');
    });

    if (
      event.currentTarget === target &&
      event.currentTarget !== pastActiveElement
    ) {
      target.parentElement.classList.toggle('active-accordion');
    }
  };

  const closeSubMegaMenu = () => {
    const mobileMegaMenus = element.querySelectorAll('.mobile-mega');
    mobileMegaMenus.forEach((mobileMega) => {
      mobileMega.classList.remove('mobile-mega');
    });
  };

  const getScrollDirection = () => {
    const scrollTop = getScrollDepth();
    const direction = scrollTop > lastScrollTop ? 'down' : 'up';

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    return direction;
  };

  const getScrollDepth = () =>
    window.pageYOffset || document.documentElement.scrollTop;

  const togglePromoBar = (target) => {
    const scrollDepth = getScrollDepth();
    const scrollDirection = getScrollDirection();

    if (scrollDepth > 44) {
      const toggle = scrollDirection === 'down' ? 'add' : 'remove';
      target.classList[toggle]('scroll-down');
    }
  };

  const removeInert = () => {
    subMegaPanels.forEach((panel) => {
      panel.removeAttribute('inert');
      // eslint-disable-next-line no-param-reassign
      panel.scrollTop = 0;
    });
  };

  const addInert = () => {
    subMegaPanels.forEach((panel) => {
      panel.setAttribute('inert', '');
    });
  };

  const isAndroid = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('android') > -1;
  };

  const removeClassControls = () => {
    if (isAndroid()) return;
    body.classList.remove(openMenuClass);
    closeSubMegaMenu();
    removeInert();
    closeSearch();
  };

  // Update the input value based on the clicked top searches pill
  const inputSearch = (value) => {
    searchInputs.forEach((inp) => {
      // eslint-disable-next-line no-param-reassign
      inp.value = value;
      inp.dispatchEvent(new Event('input'));
    });
  };

  // Highlight the top searches pills text that match the input value
  const highlightPills = (value) => {
    pills.forEach((pill) => {
      if (!value) {
        // eslint-disable-next-line no-param-reassign
        pill.innerHTML = pill.innerText;
        return;
      }

      const checkMatches = new RegExp(value, 'gi');
      const matches = pill.innerText.matchAll(checkMatches);
      let newText;

      for (const match of matches) {
        newText = pill.innerText.replaceAll(
          match,
          `<span class="font-bold">${match}</span>`,
        );
      }
      if (newText) {
        // eslint-disable-next-line no-param-reassign
        pill.innerHTML = newText;
      } else {
        // eslint-disable-next-line no-param-reassign
        pill.innerHTML = pill.innerText;
      }
    });
  };

  const searchRedirect = (e) => {
    const searchInput = e.currentTarget.parentElement.querySelector(
      '[data-target="search-input"]',
    );
    window.location.href = `/search?q=${searchInput.value}`;
  };

  init();
};
